import { supabase } from "../lib/supabaseClient";

export type Board = {
  id: string;
  title: string;
  description?: string | null;
  user_id?: string | null;
  excalidraw_data?: unknown;
  thumbnail_url?: string | null;
  is_archived?: boolean | null;
  created_at?: string;
  updated_at?: string;
};

type CreateBoardParams = {
  userId: string;
  title: string;
  excalidrawData: unknown;
};

type UpdateBoardParams = {
  boardId: string;
  userId: string;
  title?: string;
  excalidrawData: unknown;
};

export const getBoards = async (userId: string) => {
  const { data, error } = await supabase
    .from("boards")
    .select("*")
    .eq("user_id", userId)
    .or("is_archived.is.null,is_archived.eq.false")
    .order("updated_at", {
      ascending: false,
    });

  if (error) {
    throw error;
  }

  return data as Board[];
};

export const createBoard = async ({
  userId,
  title,
  excalidrawData,
}: CreateBoardParams) => {
  const { data, error } = await supabase
    .from("boards")
    .insert({
      title,
      user_id: userId,
      excalidraw_data: excalidrawData,
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data as Board;
};

export const updateBoard = async ({
  boardId,
  userId,
  title,
  excalidrawData,
}: UpdateBoardParams) => {
  const { data, error } = await supabase
    .from("boards")
    .update({
      ...(title ? { title } : {}),
      excalidraw_data: excalidrawData,
      updated_at: new Date().toISOString(),
    })
    .eq("id", boardId)
    .eq("user_id", userId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data as Board;
};

export const deleteBoard = async (boardId: string, userId: string) => {
  const { error } = await supabase
    .from("boards")
    .update({
      is_archived: true,
      updated_at: new Date().toISOString(),
    })
    .eq("id", boardId)
    .eq("user_id", userId);

  if (error) {
    throw error;
  }
};
